import React, { Component } from "react";
import { documentsTitles, saved } from "./dynamic_documents";

export class BusinessSummarySheet extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("BusinessSummarySheet");
    this.outerclass = "d-flex flex-wrap";
    this.passwordclass = "";
    this.state = {};
  }

  saved(key) {
    return saved(this, key);
  }

  uploadDocument(event, name, offsetkey = "", offsetvalue = "") {
    let { props } = this;
    let input = event.target;
    let [file] = input.files;
    let docmeta = {
      name,
      group: "credit",
      firmType: props.firmType,
      documentKey: props.documentKey,
      offsetkey,
      [offsetkey || "offsetvalue"]: offsetvalue,
    };
    let payload = {
      application_id: this.props.urlparams.application_id,
      file,
      doc_meta_name: JSON.stringify(docmeta).encode(),
    };
    this.api.execApi(
      "postDocument",
      payload,
      {},
      {
        multipart: true,
        message: "Uploading please wait...",
        onexec: () => {
          success("Upload Successfull").promise.then(() => {
            this.props.onFetchDocList && this.props.onFetchDocList();
          });
        },
      }
    );
  }

  deleteDocument(args) {
    let payload = { attachment_id: args["data-invalue"] };
    this.api.execApi("deleteDocument", {}, payload).then(() => {
      this.props.onFetchDocList && this.props.onFetchDocList();
    });
  }

  downloadDocument(args) {
    let name = args.name;
    name = name.split("business_summary_template_").join("");
    name = name.toUpperCase();
    let payload = { attachment_id: args["data-invalue"] };
    let url = this.api.getUrl("getBusinessSummaryTemplate", {
      doc_type: name,
    });
    console.log({ url, args });
    window.open(url);
  }

  storeFilePassword() {}

  getFile(name, offsetkey = "", offsetvalue = "") {
    let { props } = this;
    let { docList: uploaded = {} } = props;
    let mydoclist = uploaded[props.documentKey] ?? [];
    return mydoclist.find(
      (o) =>
        o.doc_meta_name.name == name &&
        o.doc_meta_name[offsetkey || "offsetvalue"] == offsetvalue
    );
  }

  getFileAttrs(subkey, offsetkey = "", offsetvalue = "") {
    let { props } = this;
    let file = this.getFile(subkey, offsetkey, offsetvalue);
    return {
      "data-invalue": file?.attachment_id,
      "data-filename": file?.file_name,
      isuploaded: !!file,
      labelname: file?.file_name,
    };
  }

  saveTemplate() {
    let payload = {
      business_summary_attachment_id:
        this.refs.business_summary_template.props["data-invalue"],
    };
    this.api.execApi("postBusinessSummary", payload).then(() => {
      alert("Info Updated Successfull.").promise.then(() => {
        this.props.onInfoList && this.props.onInfoList();
      });
    });
  }

  render() {
    let { props, passwordclass, outerclass } = this;
    let { documentKey } = props;
    return (
      <>
        <div className="row">
          <div className="col-12 col-md-4">
            <AppUploadPassword
              label={
                this.mixin.isClient()
                  ? documentsTitles[documentKey]["sample_template"] + " 1"
                  : documentsTitles[documentKey]["business_summary_template"]
              }
              name={"business_summary_template_a"}
              passwordclass={passwordclass}
              outerclass={outerclass}
              haspassword={false}
              onChange={(e) => this.uploadDocument(e, "sample_template_1")}
              onDelete={(...args) => this.deleteDocument(...args)}
              onDownload={(...args) => this.downloadDocument(...args)}
              accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              isuploaded={false}
              labelname={
                !!this.saved("A") ? "business_summary_template.xlsx" : null
              }
              candelete={!this.mixin.isClient()}
            />
          </div>
          <div className="col-12 col-md-4">
            <AppUploadPassword
              label={
                this.mixin.isClient()
                  ? documentsTitles[documentKey]["sample_template"] + " 2"
                  : documentsTitles[documentKey]["business_summary_template"]
              }
              name={"business_summary_template_b"}
              passwordclass={passwordclass}
              outerclass={outerclass}
              haspassword={false}
              onChange={(e) => this.uploadDocument(e, "sample_template_2")}
              onDelete={(...args) => this.deleteDocument(...args)}
              onDownload={(...args) => this.downloadDocument(...args)}
              accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              isuploaded={false}
              labelname={
                !!this.saved("B") ? "business_summary_template.xlsx" : null
              }
              candelete={!this.mixin.isClient()}
            />
          </div>
          <div className="col-12 col-md-4">
            <AppUploadPassword
              label={
                this.mixin.isClient()
                  ? documentsTitles[documentKey]["sample_template"] + " 3"
                  : documentsTitles[documentKey]["business_summary_template"]
              }
              name={"business_summary_template_c"}
              passwordclass={passwordclass}
              outerclass={outerclass}
              haspassword={false}
              onChange={(e) => this.uploadDocument(e, "sample_template_3")}
              onDelete={(...args) => this.deleteDocument(...args)}
              onDownload={(...args) => this.downloadDocument(...args)}
              accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              isuploaded={false}
              labelname={
                !!this.saved("C") ? "business_summary_template.xlsx" : null
              }
              candelete={!this.mixin.isClient()}
            />
          </div>
          <div className="col-12 col-md-4">
            <AppUploadPassword
              label={documentsTitles[documentKey]["business_summary_template"]}
              ref="business_summary_template"
              name={"business_summary_template"}
              passwordclass={passwordclass}
              outerclass={outerclass}
              haspassword={false}
              onChange={(e) =>
                this.uploadDocument(e, "business_summary_template")
              }
              onDelete={(...args) => this.deleteDocument(...args)}
              onDownload={(...args) => this.downloadDocument(...args)}
              accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              {...this.getFileAttrs("business_summary_template")}
            />
          </div>
        </div>
        <div className="row d-flex">
          <div>
            <button
              className="btn add-btn text-dark rounded-pill ml-auto"
              onClick={() => this.saveTemplate()}
            >
              Update
            </button>
          </div>
        </div>
        <hr />
      </>
    );
  }
}

export default connect(BusinessSummarySheet);
